// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.review-star-select__star[data-v-71624a04] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  list-style: none;\n  font-size: 24px;\n  color: rgba(255, 255, 255, 0.7);\n  cursor: pointer;\n}\n.review-star-select__star li[data-v-71624a04] {\n  margin-left: 8px;\n}\n.review-star-select__star li[data-v-71624a04]:first-child {\n  margin-left: 0;\n}\n.select[data-v-71624a04] {\n  color: #E74860;\n}\n", ""]);
// Exports
module.exports = exports;
